export function LogoCompact() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="-3.17 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.1589 10.512C1.42727 10.512 0.707639 10.4595 0 10.3663V16.2794C0.664461 16.3654 1.38409 16.4132 2.17089 16.4132C6.82691 16.4132 9.12014 14.7671 11.5477 13.0278C14.1456 11.1642 16.8346 9.23622 22.1863 9.23622C23.4936 9.23622 24.6402 9.3509 25.6669 9.55397V3.1965H15.8127C12.8766 7.60206 7.85359 10.5144 2.1589 10.5144V10.512Z"
        fill="black"
      />
      <path
        d="M22.1863 11.3867C17.5302 11.3867 15.237 13.0328 12.8095 14.7745C10.2116 16.638 7.52256 18.566 2.17089 18.566C1.39369 18.566 0.671657 18.523 0 18.449V28.7604H25.6669V11.757C24.6618 11.5229 23.52 11.3867 22.1863 11.3867Z"
        fill="black"
      />
      <path
        d="M0 8.19956C0.70524 8.30707 1.42487 8.36202 2.1589 8.36202C6.57264 8.36202 10.5234 6.34799 13.1333 3.19434H0V8.19717V8.19956Z"
        fill="black"
      />
    </svg>
  );
}
